/* eslint-disable camelcase */
import React from 'react';
import { Button } from '@applane/react-core-components';
import {
  View, Text, ScrollView, Image, Toast,
} from '../app-components';
import { validateEmail, validateMobile } from '../Lib/helpers';

import {
  AutoSuggestInput,
  TextInput,
} from '../app-components/input-components/Editors';
import { FormField } from '../app-components/form/field';
import { Form } from '../app-components/form/Form';
import { appraiseLogo } from '../images';
import ContactUsStyle from './ContactUsStyle';
import { h10_Montessart } from '../theme/fonts';
import { invoke } from '../AppServices';
import { ROUTES, selectDMS, selectVMPP } from '../Lib/constants';

export default () => {
  const { ContactUsLeftSide } = ContactUsStyle;

  return ({ navigation }) => {
    const handleSubmit = async ({ data }) => {
      const obj = data;

      const fromBackend = await invoke({
        id: 'dealerContacting',
        paramValue: { data: obj },
      });

      console.log('fromBackend', fromBackend)
      if (fromBackend.result) {
        Toast.show({
          message: 'Success',
          description: 'Dealer added successfully!',
          type: 'success',
          position: 'top',
          direction: 'right',
          duration: 3000,
        });
        window.location.replace(ROUTES.dealerData.name)
        // navigation.replace(ROUTES.dealerData.name);
      }
    };
    return (
      <ScrollView>
        {/* left side started */}
        <View
          style={{ flexDirection: 'row', height: '100vh' }}
        >
          {/* <View style={ContactUsLeftSide}>
            <Button
              style={{ cursor: 'pointer' }}
              onClick={() => {
                window.location.replace('/');
              }}
            >
              <Image source={appraiseLogo} style={{ width: '170px' }} />
            </Button>
            <View style={{ display: 'flex', gap: '30px' }}>
              <Text
                style={{
                  fontFamily: 'Montserrat',
                  fontSize: '36px',
                  color: '#FAFAFA',
                }}
              >
                Contact Us!
              </Text>
              <View style={{ border: '1px solid #FAFAFA', width: '68.5px' }} />
              <Text
                style={{
                  fontFamily: 'Poppins',
                  fontSize: '18px',
                  color: '#FAFAFA',
                  lineHeight: '27px',
                }}
              >
                Kindly fill in the form with your DMS, which wholesale valuation
                service you subscribe to, and your contact information and a
                representative will contact you with more information.
              </Text>
            </View>
          </View> */}
          {/* left side over */}


          <View style={ContactUsStyle.rightSide}>
            {/* right side started */}
            <View>
              <Form
                validations={{
                  email: ({ data }) => validateEmail(data.email),
                  phonenumber: ({ data }) => validateMobile(data.phonenumber),
                }}
                mandatory={{
                  username: 'This Field is mandatory',
                  dms: 'This Field is mandatory',
                  // vmpp: 'This Field is mandatory',
                  address: 'This Field is mandatory',
                  email: 'This Field is mandatory',
                  phonenumber: 'This Field is mandatory',
                }}
                required={{
                  username: 1,
                  dms: 1,
                  // vmpp: 1,
                  email: 1,
                  address: 1,
                  phonenumber: 1,
                }}
                navigation={navigation}
                scrollable={false}
                onSubmit={handleSubmit}
                bodyContainerStyle={ContactUsStyle.formBox}
                // onSubmitError={setErrorMessage}
              >
                <ContactUsFormNew navigation={navigation} />
              </Form>
            </View>
            {/* right side over */}
          </View>
        </View>
      </ScrollView>
    );
  };
};

const ContactUsFormNew = ({
  form_context: formContext,

  navigation,
}) => {
  const { handleSubmit } = formContext;

  return (
    <View id="main1" style={ContactUsStyle.boxToHoldAllFields}>
      <View id="main2" style={ContactUsStyle.boxToHoldSignupTitle}>
        Please Enter Dealer Details
      </View>
      <View id="main3" style={ContactUsStyle.boxToHoldRowFields}>
        <View id="main4" style={ContactUsStyle.boxToHoldIndividualField}>
          <FormField
            style={ContactUsStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="dms"
            label="DMS"
            variant="filled"
            onSubmitEditing={handleSubmit}
          >
            <AutoSuggestInput options={selectDMS} />
          </FormField>
        </View>

        {/* <View style={ContactUsStyle.boxToHoldIndividualField}>
          <FormField
            style={ContactUsStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="vmpp"
            label="Wholesale Valuation Subscription"
            variant="filled"
            onSubmitEditing={handleSubmit}
          >
            <AutoSuggestInput options={selectVMPP} />
          </FormField>
        </View> */}
      </View>

      <View style={ContactUsStyle.boxToHoldRowFields}>
        <View style={ContactUsStyle.boxToHoldIndividualField}>
          <FormField
            style={ContactUsStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="username"
            label="Dealership Name"
            variant="filled"
            onSubmitEditing={handleSubmit}
          >
            <TextInput />
          </FormField>
        </View>
        <View style={ContactUsStyle.boxToHoldIndividualField}>
          <FormField
            style={ContactUsStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="email"
            label="Email"
            variant="filled"
            onSubmitEditing={handleSubmit}
          >
            <TextInput />
          </FormField>
        </View>
      </View>

      <View style={ContactUsStyle.boxToHoldRowFields}>
        <View style={ContactUsStyle.boxToHoldIndividualField}>
          <FormField
            style={ContactUsStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="address"
            label="Company Address"
            variant="filled"
            onSubmitEditing={handleSubmit}
          >
            <TextInput allowWhiteSpaces />
          </FormField>
        </View>
        <View style={ContactUsStyle.boxToHoldIndividualField}>
          <FormField
            style={ContactUsStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="phonenumber"
            label="Phone Number"
            variant="filled"
            onSubmitEditing={handleSubmit}
          >
            <TextInput />
          </FormField>
        </View>
      </View>

      <View style={ContactUsStyle.boxToHoldCreateAccountButton}>
        <Button
          style={ContactUsStyle.createAccountButtonProperties}
          onClick={handleSubmit}
        >
          Submit Request
        </Button>
      </View>

      {/* <View style={ContactUsStyle.alreadyBox}>
        <View style={{ paddingRight: 10 }}>Already have an account?</View>

        <Button
          style={ContactUsStyle.alreadyLoginButtonProperties}
          onClick={() => {
            navigation.replace('login');
          }}
        >
          Log in
        </Button>
      </View> */}
    </View>
  );
};
